"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApi = exports.setIntervalRefreshToken = exports.setApi = exports.updateRefreshTokenTime = void 0;
const axios_1 = __importDefault(require("axios"));
const token_1 = require("./token");
const refreshToken_1 = require("./refreshToken");
const configApi = {
    api: null
};
exports.updateRefreshTokenTime = 5 * 60;
const getNextRefresh = () => {
    const token = (0, token_1.getToken)();
    if (!token)
        return 0;
    const currentTime = new Date().getTime();
    const saveTokenTime = new Date(token.saveDate).getTime();
    return token.expiresIn - (currentTime - saveTokenTime) / 1000;
};
const setApi = (api) => {
    configApi.api = api;
    axios_1.default.defaults.baseURL = api;
    const token = (0, token_1.getToken)();
    if (token) {
        (0, token_1.setBearer)(token.accessToken);
        if (getNextRefresh() < exports.updateRefreshTokenTime) {
            return (0, refreshToken_1.refreshTokenAsync)().catch((error) => {
                (0, exports.setIntervalRefreshToken)();
                console.error(error);
            });
        }
        (0, exports.setIntervalRefreshToken)();
    }
    return Promise.resolve();
};
exports.setApi = setApi;
let interval;
const setIntervalRefreshToken = () => {
    if (interval)
        clearInterval(interval);
    interval = setInterval(() => {
        const token = (0, token_1.getToken)();
        if (token && token.accessToken)
            (0, token_1.setBearer)(token.accessToken);
        if (getNextRefresh() < exports.updateRefreshTokenTime) {
            (0, refreshToken_1.refreshTokenAsync)().catch((error) => {
                (0, exports.setIntervalRefreshToken)();
                console.error(error);
            });
            clearInterval(interval);
        }
    }, 1000);
};
exports.setIntervalRefreshToken = setIntervalRefreshToken;
const getApi = () => configApi.api;
exports.getApi = getApi;
